export default {
  appBrand: "Center AI",
  facebookColor: "#4766CE",
  googleColor: "#CB2929",
  turquoiseColor: "#27C1BC",
  lightGrayColor: "#E1E1E1",
  centerAiEmail: "support@center.ai",
  supportEmail: "damian.kordyla@center.ai",
  neonetSLUrl: "https://sklepy.neonet.pl/",
  regulations: "https://center.ai/pl/regulamin-serwisu/",
  privacyPolicy: "https://center.ai/pl/polityka-prywatnosci-2/",
  regulationsEn: "https://center.ai/terms-of-use-2/",
  privacyPolicyEn: "https://center.ai/privacy-policy-2/",
  blockEmailDomains: ["@appchance.com", "@example.com"],
  blockedEmailAddresses: ["admin-readonly@center.ai"],
  faq: { pl: "https://help.center.ai/", en: "https://help.center.ai/en/" },
  fullPeriod: "full",
  absoluteStartDate: "2005-01-01"
};
